import {
  type FC,
} from 'react';
import {
  IconButton,
} from '@mui/joy';
import {
  GiftsIcon,
  BeamEffectIcon
} from '../assets';
import {
  PLAYER_REWARDS_TOGGLE_EVENT
} from '../config';

export type PlayerRewardsPopupToggleProps = {
  onClick?(): void;
};

export const PlayerRewardsPopupToggle: FC<PlayerRewardsPopupToggleProps> = ({ onClick }) => (
  <IconButton
    onClick={() => {
      document.dispatchEvent(new CustomEvent(PLAYER_REWARDS_TOGGLE_EVENT));
      onClick?.();
    }}
    sx={{
      width: 36,
      height: 36,
      position: 'relative',
      overflow: 'hidden',
      // TODO: Replace with theme palette colors in the future
      backgroundColor: '#252C37',
      '&:hover': { backgroundColor: '#434A55' },
    }}>
    <GiftsIcon
      style={{
        width: 24,
        height: 24,
        animation: 'pulseGift 6s ease-in-out .5s infinite',
      }}
    />
    <BeamEffectIcon
      style={{
        width: '100%',
        bottom: '-13%',
        position: 'absolute',
      }}
    />
  </IconButton>
);